module.exports = __webpack_public_path__ + "img/Logo_GFDRR.8f0cdb93.png";